import { render, staticRenderFns } from "./DatasetCard.vue?vue&type=template&id=380d3f2f&scoped=true"
import script from "./DatasetCard.vue?vue&type=script&lang=js"
export * from "./DatasetCard.vue?vue&type=script&lang=js"
import style0 from "./DatasetCard.vue?vue&type=style&index=0&id=380d3f2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d3f2f",
  null
  
)

export default component.exports